// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"cb0fe5de","453":"d3cd6754","455":"3fcaae1a","977":"643e62a8"}[chunkId] + ".chunk.js";
};